import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { RouterPath } from "../../../assets/dictionary/RouterPath";
import ConfirmEmailService from "./ConfirmEmailService";
import { Button } from "../../../components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "../../../components/ui/card";
import { CheckCircle } from "lucide-react";

export default function ConfirmEmail() {
  const [isLoading, setIsLoading] = useState(true);
  const [isValid, setIsValid] = useState(false);
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get("token");

  useEffect(() => {
    const confirm = async () => {
      if (!token) {
        navigate(RouterPath.LINK_NOT_VALID);
        return;
      }
      try {
        const response = await ConfirmEmailService.postConfirmEmail(token);
        if (response.status === 200) {
          setIsValid(true);
        } else {
          navigate(RouterPath.LINK_NOT_VALID);
        }
      } catch (e) {
        navigate(RouterPath.LINK_NOT_VALID);
      } finally {
        setIsLoading(false);
      }
    };
    confirm();
  }, [token, navigate]);

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center p-4 app-page-gradient">
        <div className="w-full max-w-md">
          <Card className="glass-card border-muted shadow-2xl">
            <CardHeader className="text-center">
              <CardTitle className="text-2xl font-bold text-high-contrast">Confirmation en cours...</CardTitle>
              <CardDescription className="text-muted-foreground">Veuillez patienter.</CardDescription>
            </CardHeader>
          </Card>
        </div>
      </div>
    );
  }

  if (!isValid) return null;

  return (
    <div className="min-h-screen flex items-center justify-center p-4 bg-background">
      <div className="w-full max-w-md">
        <Card className="glass-card border-0 shadow-2xl">
          <CardHeader className="text-center space-y-4">
            <div className="w-16 h-16 bg-green-100 dark:bg-green-900 rounded-full flex items-center justify-center mx-auto">
              <CheckCircle className="h-8 w-8 text-green-600 dark:text-green-400" />
            </div>
            <CardTitle className="text-2xl font-bold text-high-contrast">Email confirmé</CardTitle>
            <CardDescription className="text-muted-foreground">
              Votre email a été confirmé avec succès. Vous pouvez maintenant vous connecter.
            </CardDescription>
          </CardHeader>
          <CardContent>
            <Button className="w-full" onClick={() => navigate(RouterPath.LOGIN)}>
              Se connecter
            </Button>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
